const env = process.env.NODE_ENV
console.log('---env--', env);
export const BASE_URL = '/'
export const API_URL = '/api'
export const UPLOAD_URL = API_URL + '/upload'
export const IMG_URL = 'https://56yunjia-1316666589.cos.ap-shanghai.myqcloud.com/'
